export const SUBUSER_TOKEN_KEY = `${process.env.REACT_APP_PROJECT_ID}-idSubuserToken`;

// {new-country-onboarding} Add new language here
export const LANGUAGES = [
  { id: 'se', name: 'Swedish' },
  { id: 'en', name: 'English' },
  { id: 'es', name: 'Spanish' },
  { id: 'no', name: 'Norwegian' },
  { id: 'dk', name: 'Danish' },
  { id: 'tr', name: 'Turkish' },
  // { id: 'ar', name: 'Arabic' },
];

// {new-country-onboarding} DON'T Add new currencies here,
// as we map using company.country beyond these markets
export const CURRENCIES = [
  { id: 'EUR', name: 'EURO' },
  { id: 'SEK', name: 'SEK' },
  { id: 'GBP', name: 'GBP' },
  { id: 'DKK', name: 'DKK' },
  { id: 'NOK', name: 'NOK' },
  { id: 'USD', name: 'USD' },
];

export const VAT_VALUES = [0, 4, 5, 6, 10, 12, 15, 20, 21, 25];
